import { REGEX_PATTERN } from "core/const/validator.const";

export const BaseFields = [
  {
    type: "text",
    name: "first_name",
    placeholder: "signup.placeholder.firstname",
    validation: { required: "Firstname is required" },
  },
  {
    type: "text",
    name: "last_name",
    placeholder: "signup.placeholder.surname",
    validation: { required: "Lastname is required" },
  },
  {
    type: "email",
    name: "email",
    placeholder: "signup.placeholder.email",
    validation: {
      required: "Email is required",
      pattern: {
        value: REGEX_PATTERN.email,
        message: "Please enter the valid email",
      },
    },
  },
  {
    type: "text",
    name: "phone_number",
    placeholder: "signup.placeholder.phone_number",
    validation: {
      required: "Phone number is required",
      pattern: {
        value: REGEX_PATTERN.phone, // Ensure REGEX_PATTERN.phoneNumber exists in validator.const
        message: "Please enter a valid phone number, eg : +44444444444",
      },
    },
  },
];

export const PasswordField = [
  {
    type: "password",
    name: "password",
    placeholder: "signup.placeholder.create_password",
    validation: {
      required: "Password is required",
      maxLength: {
        value: 48,
        message: "Password must be within 48 characters",
      },
      pattern: {
        value: REGEX_PATTERN.password,
        message: "Invalid password Format",
      },
    },
  },
];

export const redirectDomains = window.location.href.includes("accounts.")
  ? {
      landlord_works: "https://sa105.gosimpletax.com",
      qdos: "https://qdos.gosimpletax.com",
    }
  : {};

export const BUTTON_PROPS = {
  value: "Resend activation Email",
  href: "/resend-activation",
};

export const EmailConsentField = {
  type: "checkbox",
  name: "email_consent",
  label: "signup.email_consent.label",
};
export const SignupResponseMessage = {
  success: "User successfully created. Please wait a few moments.",
  error: "User already exists. Please try another email.",
};
